<script>
  import { Tooltip } from '@sveltestrap/sveltestrap';
  import { v4 as uuidv4 } from 'uuid';

  export let label = null;
  export let tooltip = null;
  export let tooltipIcon = 'os-icon-help-circle';

  export let error = undefined;

  const id = `tooltip-${uuidv4()}`;
</script>

<div class="field-label" class:error {...$$props}>
  <span>{@html label}</span>

  {#if tooltip}
    <i {id} class={tooltipIcon} />
    <Tooltip target={id}>
      {@html tooltip}
    </Tooltip>
  {/if}
</div>

<style lang="scss" src="./label.scss"></style>
